import type { Team } from '@/types';

// Mock Premier League teams for 2024/25 season
export const mockTeams: Team[] = [
  {
    id: 1,
    name: 'Arsenal',
    mediumName: 'Arsenal',
    code: 'ARS',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t3.svg',
    externalApiId: 3,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 2,
    name: 'Aston Villa',
    mediumName: 'Aston Villa',
    code: 'AVL',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t7.svg',
    externalApiId: 7,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 3,
    name: 'Bournemouth',
    mediumName: 'Bournemouth',
    code: 'BOU',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t91.svg',
    externalApiId: 91,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 4,
    name: 'Brentford',
    mediumName: 'Brentford',
    code: 'BRE',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t94.svg',
    externalApiId: 94,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 5,
    name: 'Brighton & Hove Albion',
    mediumName: 'Brighton',
    code: 'BHA',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t36.svg',
    externalApiId: 36,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 6,
    name: 'Chelsea',
    mediumName: 'Chelsea',
    code: 'CHE',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t8.svg',
    externalApiId: 8,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 7,
    name: 'Crystal Palace',
    mediumName: 'Crystal Palace',
    code: 'CRY',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t31.svg',
    externalApiId: 31,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 8,
    name: 'Everton',
    mediumName: 'Everton',
    code: 'EVE',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t11.svg',
    externalApiId: 11,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 9,
    name: 'Fulham',
    mediumName: 'Fulham',
    code: 'FUL',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t54.svg',
    externalApiId: 54,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 10,
    name: 'Leeds United',
    mediumName: 'Leeds',
    code: 'LEE',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t2.svg',
    externalApiId: 2,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 11,
    name: 'Sunderland',
    mediumName: 'Sunderland',
    code: 'SUN',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t56.svg',
    externalApiId: 56,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 12,
    name: 'Liverpool',
    mediumName: 'Liverpool',
    code: 'LIV',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t14.svg',
    externalApiId: 14,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 13,
    name: 'Manchester City',
    mediumName: 'Man City',
    code: 'MCI',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t43.svg',
    externalApiId: 43,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 14,
    name: 'Manchester United',
    mediumName: 'Man United',
    code: 'MUN',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t1.svg',
    externalApiId: 1,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 15,
    name: 'Newcastle United',
    mediumName: 'Newcastle',
    code: 'NEW',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t4.svg',
    externalApiId: 4,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 16,
    name: 'Nottingham Forest',
    mediumName: "Nott'm Forest",
    code: 'NFO',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t17.svg',
    externalApiId: 17,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 17,
    name: 'Burnley',
    mediumName: 'Burnley',
    code: 'BUR',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t90.svg',
    externalApiId: 90,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 18,
    name: 'Tottenham Hotspur',
    mediumName: 'Spurs',
    code: 'TOT',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t6.svg',
    externalApiId: 6,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 19,
    name: 'West Ham United',
    mediumName: 'West Ham',
    code: 'WHU',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t21.svg',
    externalApiId: 21,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
  {
    id: 20,
    name: 'Wolverhampton Wanderers',
    mediumName: 'Wolves',
    code: 'WOL',
    logoUrl: 'https://resources.premierleague.com/premierleague/badges/t39.svg',
    externalApiId: 39,
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
  },
];

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const mockTeamsService = {
  getTeams: async (): Promise<Team[]> => {
    console.log('[MOCK TEAMS] Getting all teams');
    await delay(200);
    return mockTeams;
  },
};
